<!-- 收费策略 -->
<template>
  <e-dialog
    dialogTitle="收费策略"
    :centerDialogVisible="chargeVisible"
    @resetPopupData="chargeCancel"
    @submitPopupData="chargeSave"
    :popupWidth="'500px'"
    :destroyClose="true"
    :modalAppendToBody="false"
    onlyShowCancel
    cancelButtonTip="我知道了"
  >
    <el-form ref="form" :model="auditForm" :rules="rules" label-width="130px">
      <div v-for="(item, index) in auditForm.rateList" class="rate-item">
        <div class="title" v-if="item.rateType === 2">易资源分佣比例</div>
        <div class="title" v-if="item.rateType === 1">询比价服务费率</div>
        <el-form-item
          v-if="item.rateType === 2"
          label="资源引入方："
          :rules="rules.resourceRate"
          :prop="'rateList.' + index + '.resourceRate'"
        >
          <!-- <el-input
            oninput="value=value.replace(/[^0-9.]/g,'')"
            type="text"
            placeholder="请输入内容"
            v-model="item.resourceRate"
          ></el-input> -->
          <span>{{ item.resourceRate }}</span>
          <span class="symbol">%</span>
        </el-form-item>
        <el-form-item
          label="平台方："
          :rules="rules.platformRate"
          :prop="'rateList.' + index + '.platformRate'"
        >
          <!-- <el-input
            oninput="value=value.replace(/[^0-9.]/g,'')"
            type="text"
            placeholder="请输入内容"
            v-model="item.platformRate"
          ></el-input> -->
          <span>{{ item.platformRate }}</span>
          <span class="symbol" v-if="item.rateType === 2">%</span>
          <span class="symbol" v-if="item.rateType === 1">‰</span>
        </el-form-item>
        <el-form-item
          label="客户引入方："
          :rules="rules.customRate"
          :prop="'rateList.' + index + '.customRate'"
        >
          <!-- <el-input
            oninput="value=value.replace(/[^0-9.]/g,'')"
            type="text"
            placeholder="请输入内容"
            v-model="item.customRate"
          ></el-input> -->
          <span>{{ item.customRate }}</span>
          <span class="symbol" v-if="item.rateType === 2">%</span>
          <span class="symbol" v-if="item.rateType === 1">‰</span>
        </el-form-item>
        <el-form-item
          v-if="item.rateType === 1"
          label="总服务费率："
          :prop="'rateList.' + index + '.totalRate'"
        >
          <span style="color: #e50113">{{ item.totalRate }}</span>
          <span class="symbol" style="color: #e50113">‰</span>
        </el-form-item>
      </div>
    </el-form>
  </e-dialog>
</template>

<script>
import EDialog from '@/components/common/e-dialog';
import Api from '@/modules/projectA/api/filing';
export default {
  props: {
    chargeVisible: {
      type: Boolean,
      default: false,
    },
    auditData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      auditForm: {
        rateList: [
          {
            rateType: 2,
            resourceRate: '',
            platformRate: '',
            customRate: '',
          },
          {
            rateType: 1,
            platformRate: '',
            customRate: '',
            totalRate: '',
          },
        ],
      },
      rules: {
        /* resourceRate: [
          { required: true, message: '请输入资源引入方', trigger: 'blur' },
        ],
        platformRate: [
          { required: true, message: '请输入平台方', trigger: 'blur' },
        ],
        customRate: [
          { required: true, message: '请输入客户引入方', trigger: 'blur' },
        ], */
      },
    };
  },
  components: { EDialog },
  mounted() {
    this.getQueryFilingRateList();
  },
  methods: {
    async getQueryFilingRateList() {
      // 传resourceId和filingCompanyId就行
      const { resourceId, filingCompanyId } = this.auditData;
      const result = await Api.queryFilingRateList({
        resourceId,
        filingCompanyId,
      });
      console.log(result, '复审');
      if (result.code === '200') {
        this.auditForm.rateList = [...result.data];
      }
    },
    // 修改收费策略

    chargeCancel() {
      this.$emit('update:chargeVisible', false);
      this.$refs['form'].clearValidate();
    },
    chargeSave() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const itemObj = this.auditForm.rateList.find(
            (item) => item.rateType === 2
          );
          const {
            resourceRate = 0,
            platformRate = 0,
            customRate = 0,
          } = itemObj;
          const total =
            Number(resourceRate) + Number(platformRate) + Number(customRate);
          if (total !== 100) {
            return this.$message.warning('三项比例相加需等于100！');
          }
          const secondObj = this.auditForm.rateList.find(
            (item) => item.rateType === 1
          );
          const { platformRate: platformRateAl, customRate: customRateAl = 0 } =
            secondObj;
          const totalAl = Number(platformRateAl) + Number(customRateAl);
          if (totalAl > 1000) {
            return this.$message.warning(
              '询比价服务费率两项比例相加不能大于1000！'
            );
          }
          const { rateList } = this.auditForm;
          const result = await Api.updateFilingRate({ rateList });
          if (result.code === '200') {
            this.$message.success('操作成功');
            this.chargeCancel();
          }
        }
      });
    },
  },
  watch: {
    'auditForm.rateList': {
      handler(newVal) {
        for (let i = 0; i < newVal.length; i++) {
          const item = newVal[i];
          if (item.rateType === 1) {
            item.totalRate =
              Number(item.platformRate) + Number(item.customRate);
          }
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.rate-item {
  padding: 20px 0 8px 20px;
  background: #f8f8f8;
  .title {
    margin-bottom: 10px;
    font-weight: 500;
  }
  &:last-child {
    margin-top: 20px;
  }
  ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 6px;
  }
}
::v-deep .el-input {
  width: 220px;
}
/* .symbol {
  margin-left: 10px;
} */
</style>
